(function(angular) {
    'use strict';

    angular.module('GorillaBoy.services')
    .factory('LogoService', [
        '$rootScope',
        '$http',
        '$log',
        'EndpointConfig',
        'AppConstants',
        LogoServiceFactoryFn
    ]);

    function LogoServiceFactoryFn($rootScope, $http, $log, EndpointConfig, AppConstants) {
        return {
            checkIfCustomClientLogoExists : function() {
                $rootScope.clientLogoUrl = '';
                var url = AppConstants.LOGO_URL_PREFIX + EndpointConfig.organization() + "_logo.png";
                $http.get(url).then(function(response) {
                    $rootScope.clientLogoUrl = url;
                });
            }
        };
    }
}(angular));